import type PlayClient from '@empathybroker/tsclient-play'
import type { ActionTypeEnum } from '@empathybroker/tsclient-play/dist/enums/action-type.enum'
import type { EndpointEnum } from '@empathybroker/tsclient-play/dist/enums/endpoint.enum'
import type { Action } from '@empathybroker/tsclient-play/dist/models/action'
import type { AccessTokenProvider } from '@empathyco/playboard-core-domain'
import type { ActionContext } from 'vuex'
import type { CrudDataTypeEnum } from '../../../enums'

import type { ActionClass, CrudState } from '../../../models'

import { EngagementActionsTypeEnum } from '@empathybroker/tsclient-stats/dist/enums/engagement/engagement-actions-type.enum'

import { CONTAINER } from '../../../config'
import { TYPES } from '../../../config/inversify.types'
import { FetchDataAction } from '../../../store/crud/actions/fetch-data.action'
import { CRUD_CONSTS } from '../../../store/crud/crud.consts'

export class UpdateAction implements ActionClass {
  static async execute(
    this: void,
    { dispatch, commit, state }: ActionContext<CrudState, any>,
    payload: { dataType: CrudDataTypeEnum; items: any[]; files?: FormData },
  ): Promise<any[]> {
    commit(CRUD_CONSTS.mutations.setState, {
      dataType: payload.dataType,
    })

    const serviceClient = FetchDataAction.getServiceClient(payload.dataType)
    const authToken = await CONTAINER.get<AccessTokenProvider>(TYPES.AccessTokenProvider)()
    return new Promise((resolve, reject) => {
      Promise.all(
        UpdateAction.getServiceRequests(
          payload.dataType,
          serviceClient,
          authToken,
          payload.items,
          payload.files,
        ),
      )
        .then(async (responses: any[]) => {
          const data = state.data.map((dataItem: any) => {
            const dataItemResponse = responses.find(
              (response: any) => response.data.id === dataItem.id,
            )
            return dataItemResponse ? dataItemResponse.data : dataItem
          })
          commit(CRUD_CONSTS.mutations.setState, {
            data,
          })
          await dispatch(`${CRUD_CONSTS.actions.tag}`, {
            featureId: payload.dataType,
            type: EngagementActionsTypeEnum.EDIT,
          })
          resolve(responses)
        })
        .catch(reject)
    })
  }

  private static getServiceRequests(
    dataType: CrudDataTypeEnum,
    serviceClient: PlayClient,
    authToken: string,
    items: any[],
    files?: FormData,
  ): Promise<any>[] {
    const endpoint: EndpointEnum = FetchDataAction.getPlayEndpointFromDomain()
    return items.map((item: Action) =>
      (serviceClient as PlayClient).update(
        authToken,
        dataType as ActionTypeEnum,
        item,
        files,
        endpoint,
      ),
    )
  }
}
